import {sendToStatist, updateUserPropsInStatist} from './methods';
import {trackSearchUpperScreenType} from './event_trackers/track_search_upperscreen_type';

export const useStatist = () => ({
    sendToStatist,
    updateUserPropsInStatist,
    trackSearchUpperScreenType,
});

